import { AnimationItem } from 'lottie-web';

// The LottieController is designed to abstract away some of the complexity from the AnimationItem from lottie-web.
// As more functionality from the AnimationItem is needed, the LottieController can be expanded,
// but this should help developers focus on the core functions needed to play lottie animations.
type LottieController = {
  setFrame: (frame: number) => void;
  play: (startFrame?: number, endFrame?: number) => void;
  stop: () => void;
};

export const createLottieController = (animationItem: AnimationItem): LottieController => {
  const { totalFrames } = animationItem;
  return {
    setFrame: (frame: number) => {
      animationItem.goToAndStop(frame, true);
    },
    play: (startFrame = 0, endFrame = totalFrames) => {
      animationItem.playSegments([startFrame, endFrame], true);
    },
    stop: () => {
      animationItem.stop();
    }
  };
};

export default LottieController;
